import Vue from "vue";
import Vuex from "vuex";

import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.config.devtools = true;
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        mainProducts: [],
        addonProducts: [],
        cardProducts: [],
        selectedMainProduct: null,
        selectedAddonProducts: [],
        selectedCardProduct: null,
        selectedIndividualAddons: [],
        savedCardProduct: null,
        //New Variables
        maxCapacity: 135,
        occasions: [],
        categories: {},
        selectedOccasion: [],
        selectedCategories: ["View All"],
        boxQty: 1,
        productLimit: 10,
        selectedSort: "1",
        selectedFilters: [],
        rangePrice: { min: 0, max: 999 },
        boxName: "",
        cartNames: [],
        defaulBoxName: "Box 1",
        feeProduct: null,
        customData: [],
        //Mobile Filter Variables START
        selectedSortMobile: "1",
        selectedFiltersMobile: [],
        rangePriceMobile: { min: 0, max: 999 },
        selectedOccasionMobile: [],
        selectedCategoriesMobile: ["View All"],
        //Mobile Filter Variables END
        selectedCardsOccasions: ["View All"],
        selectedCardsOccasionsMobile: ["View All"],
        cartQty: 0,
        savedKey: null,
        isPage: true,
        multishipCallout: true,
        cardHasMessage: false,
        showCardAlert: false
    },
    getters,
    mutations,
    actions
});

export default store;
